import { render, staticRenderFns } from "./detailPageLoader.vue?vue&type=template&id=46308157&scoped=true"
import script from "./detailPageLoader.vue?vue&type=script&lang=js"
export * from "./detailPageLoader.vue?vue&type=script&lang=js"
import style0 from "./detailPageLoader.vue?vue&type=style&index=0&id=46308157&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46308157",
  null
  
)

export default component.exports